import { createAction } from '@reduxjs/toolkit';
import {
  CreateCounteragentAction,
  GetCounteragentParams,
  TCheckCounteragentIsExistParams,
  UpdateCounteragentAction,
} from './types';

export const getCounteragent = createAction<GetCounteragentParams>(
  'counteragent/getCounteragent',
);

export const createCounteragent = createAction<CreateCounteragentAction>(
  'counteragent/createCounteragent',
);

export const updateCounteragent = createAction<UpdateCounteragentAction>(
  'counteragent/updateCounteragent',
);

export const checkCounteragentIsExist = createAction<TCheckCounteragentIsExistParams>(
  'counteragent/checkCounteragentIsExist',
);
